import { initializeApp } from 'firebase/app'
import { getFirestore, collection } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'

const config = {
  apiKey: 'AIzaSyDaTiu97ndEMHIc1z9h6jV-63hygazwOQM',
  authDomain: 'main-basis-252709.firebaseapp.com',
  databaseURL: 'https://main-basis-252709.firebaseio.com',
  projectId: 'main-basis-252709',
  storageBucket: 'main-basis-252709.appspot.com',
  messagingSenderId: '609281588049',
  appId: '1:609281588049:web:d0d832b3eacc4432c87170'
}

const app = initializeApp(config)

// Firebase utils
const db = getFirestore(app)
const auth = getAuth(app)

// Firebase collections
const usersCollection = collection(db, 'users')

export { db, auth, usersCollection }
